<template>
    <div class="row">
        <div v-show="!loading" class="col-12 mb-4">
            <h1>{{ stage.title }}</h1>
            <p class="h5 mb-0">{{ stage.note }}</p>
        </div>
        <div
            v-for="form in sortedForms"
            :key="form.id"
            class="col-md-6 mb-3"
        >
            <div class="list-group border-radius-2 no-border">
                <router-link
                    class="list-group-item"
                    tabindex="0"
                    :aria-label="form.title"
                    :to="`/forms/${form.id}/responses/new/stage/${stage.id}`"
                >
                    {{ form.title }}
                </router-link>
            </div>
        </div>
        <div
            v-for="test in stage.tests"
            :key="test.id"
            class="col-md-6 mb-3"
        >
            <div class="list-group border-radius-2 no-border">
                <router-link
                    class="list-group-item"
                    tabindex="0"
                    :aria-label="test.Name"
                    :to="`/tests/new/${test.id}`"
                >
                    {{ test.Name }}
                </router-link>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    components: {},
    mounted() {
        this.fetchStage().then(() => {
            this.loading = false
        })
    },
    data() {
        return {
            loading: true,
            stage: {},
        }
    },
    methods: {
        fetchStage() {
            this.$store.commit('showBlockingSpinner')

            return this.$cfetch(`${this.$settings.APIBaseURL}/workflows/stages/get`, {
                method: 'GET',
                data: {
                    id: this.$route.params.stageId
                }
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching workflow stage')

                this.stage = res.result;

                //Auto redirect if we only have one item
                if (this.stage.forms.length === 1 && this.stage.tests.length === 0) this.$router.replace(`/forms/${this.stage.forms[0].id}/responses/new/stage/${this.stage.id}`);
            	if (this.stage.tests.length === 1 && this.stage.forms.length === 0) this.$router.replace(`/tests/new/${this.stage.tests[0].id}`);


            }).catch(err => {
                this.$log.error.call(err)

                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-stage'),
                    confirmCallBack: () => {
                        this.$router.push('/')
                    }
                })
            }).finally(() => {
                this.$store.commit('hideBlockingSpinner')
            })
        }
    },
    computed: {
        sortedForms() {
            return this.stage.forms ? this.stage.forms.slice().sort((a, b) => a.title.localeCompare(b.title)) : [];
        }
        // sortedForms() {
        //     return this.stage.forms.slice().sort((a, b) => a.title.localeCompare(b.title));
        // }
    }
}
</script>
